import React from 'react'
import PropTypes from 'prop-types'

class GeneralTr extends React.Component {
  render() {
    return(
      <tr>
        <th className="fix-table-width">
          {this.props.fieldName}
        </th>
        <td>
          {this.props.fieldValue ? (
            <span>
              {this.props.fieldValue}
            </span>
          ) : (
            '-'
          )}        
        </td>
      </tr>
    )
  }
}

GeneralTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string
}

export default GeneralTr
